import {BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import HomePage from "./Pages/HomePage";
import {  Container } from '@mui/material';
import Background from "./Components/Background";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { useState } from 'react';
import Layout from './Pages/Layout';
import useMediaQuery from '@mui/material/useMediaQuery';
import OldPaper from './Pages/OldPaper';
import { ROUTE_HOME_PAGE, ROUTE_OLDPAPER } from './utils';

function App() {
//   const matches = useMediaQuery('(min-width:1000px)');

// const[modalEmail,setModalEmail] = useState();

// console.log(modalEmail)

  return (
    
       <Routes>
        <Route path='/'  element={<OldPaper/>}></Route>
        <Route key={ROUTE_OLDPAPER} path={ROUTE_OLDPAPER} element={<OldPaper/>}/>
        <Route path={ROUTE_HOME_PAGE} key={ROUTE_HOME_PAGE} element={<HomePage/>} />
       </Routes>
 
  );
}

export default App;
